import type { CalendarProps } from "../calendar";
import type { CalendarBase } from "./calendar-base";
import type { CalendarContextValue } from "../context/calendar/calendar-context";

export interface CalendarRangeProps extends CalendarBase {
	mode: "range";
	selected: DateRange;
	onSelect: (input: DateRange) => void;

	/**
	 * プリセットオプションを表示するかどうか
	 * @default false
	 */
	showPresetOptions?:
		| "not-show-preset-options" //
		| "exclude-past-options"
		| "exclude-future-options"
		| "all-options";
}

export type DateRange = { from: string | undefined; to: string | undefined };

export function isDayPickerRange(
	props: CalendarProps | CalendarContextValue, //
): props is CalendarRangeProps {
	return props.mode === "range";
}
